@import '../../../global/component.css';

:host {
  display: block;
}

[summary] {
  font-size: .9rem;
}

.hero {
  box-shadow: var(--shadow);
}

@media print {

  :host {
    display: none;
  }
}